import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import useModalClose from 'hooks/useModalClose'
import { CursorPointer, Flex, ItemsGrid, ModalScrollContainer, ThinSeparator } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IInventoryIssueRow } from 'types/inventoryControl.interface'
import { formatDateForDisplay } from 'utils/helpers'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { formatGhs } from 'pages/FuelManagement/Shared/fuelFormatters'
import { chargeToDisplay } from '../Shared/inventoryFormatters'
import { IssueValueText } from './InventoryIssues.styled'

export const ViewInventoryIssueModal = ({ closeModal, value }: { closeModal: any, value?: IInventoryIssueRow }) => {
    useFocusFirstInput()
    useModalClose(closeModal)

    return <Modal black>
        <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
            <TitleText weight='bold' >Issue Preview</TitleText>
            <CursorPointer onClick={closeModal} >
                <CloseIcon />
            </CursorPointer>
        </Flex>
        <ModalScrollContainer>
            <ItemsGrid columns={2} >
                <TextDisplayCard title={formatDateForDisplay(value.date)} labelText='Date' />
                <TextDisplayCard title={value.performedByUser ? value?.performedByUser?.firstName + ' ' + value?.performedByUser?.lastName : '/'} labelText='Performed By' />
                <TextDisplayCard title={value.assignedForUser ? value?.assignedForUser?.firstName + ' ' + value?.assignedForUser?.lastName : '/'} labelText='Issued to' />
                <TextDisplayCard title={value.fromLocation ? value.fromLocation.name : '/'} labelText='From location' />
            </ItemsGrid>

            {value.control && (
                <>
                    <ThinSeparator />
                    <Flex column gap='1rem'>
                        <Flex center gap='0.5rem'>
                            <BodyText weight='bold' >Charging:</BodyText>
                            {value.control.valueGhs != null && (
                                <IssueValueText>{formatGhs(value.control.valueGhs)}</IssueValueText>
                            )}
                        </Flex>
                        <TextDisplayCard title={chargeToDisplay(value.control.chargeTo)} labelText='Charged to' width='100%' />
                        {value.notes && <TextDisplayCard title={value.notes} labelText='Notes' width='100%' />}
                    </Flex>
                </>
            )}

            <ThinSeparator />
            <Flex column gap='1rem'  >
                <BodyText weight='bold' >Items:</BodyText>
                {value.lines.map(l => <Flex key={l.id} column width='100%'>
                    <Flex width='100%' gap='1rem'  >
                        <TextDisplayCard width='100%' title={l.inventoryItem ? l.inventoryItem.name : '/'} labelText='Item' />
                        <TextDisplayCard width='100%' title={l.quantity} labelText='Quantity' />
                    </Flex>
                    <TextDisplayCard style={{ marginTop: '1rem' }} title={l.lineNotes || '/'} labelText='Notes' width='100%' />
                    <ThinSeparator margin='0.5rem 0' />

                </Flex>)}
            </Flex>
        </ModalScrollContainer>
    </Modal>
}
